import { render, staticRenderFns } from "./ListAssets.vue?vue&type=template&id=d4b2655e"
import script from "./ListAssets.vue?vue&type=script&lang=js"
export * from "./ListAssets.vue?vue&type=script&lang=js"
import style0 from "./ListAssets.vue?vue&type=style&index=0&id=d4b2655e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports